export const PICKUP = 'pickup';
export const DROPOFF = 'dropoff';

export const RETURN = 'return';

export const WAYPOINT_STATE_PENDING = 'pending';
export const WAYPOINT_STATE_ARRIVED = 'arrived';
export const WAYPOINT_STATE_FINISHED = 'finished';
export const WAYPOINT_STATE_DELIVERY_FAILED = 'delivery_failed';

export const ORDER_STATE_CANCELLED = 'cancelled';
export const ORDER_STATE_PENDING_ASSIGNMENT = 'pending_assignment';



// WEBPACK FOOTER //
// ./src/utils/constants.js